import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36804510"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "loading-wrapper",
  role: "status"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader-inner" })
], -1))
const _hoisted_3 = { class: "loading-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.locales.loading) + "... ", 1)
  ]))
}